import { type SourcingCampaignIndex } from 'api-clients/monolith';

import { getRangeTimeZoneLabel, localDayAt } from '@/utils/time-zone';

/**
 * The zone label for a campaign row, named for the campaign's own run at its
 * opening. A campaign with no start or no end has no single abbreviation, so it
 * names the zone alone.
 * @param campaign - The row. eg { time_zone: 'America/Chicago', start_date: '2026-08-30T14:04:00Z', end_date: null }
 * @returns The label, or null for an unknown zone. eg 'America/Chicago (CDT)'
 */
export function getCampaignTimeZoneLabel(
  campaign: Pick<
    SourcingCampaignIndex,
    'time_zone' | 'start_date' | 'end_date'
  >,
): string | null {
  const { time_zone: timeZone, start_date: start, end_date: end } = campaign;

  if (!start || !end) {
    return localDayAt(new Date(), timeZone) ? timeZone : null;
  }

  const startDay = localDayAt(new Date(start), timeZone);
  const endDay = localDayAt(new Date(end), timeZone);
  if (!startDay || !endDay) return null;
  return getRangeTimeZoneLabel(startDay, endDay, timeZone);
}
